import { Injectable, Inject, PLATFORM_ID, Injector, Optional, REQUEST } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '../../../environments/environment';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { IntlService } from './intl.service';
import { sha256 } from 'js-sha256';

export interface Diacritics {
  letter: string;
  diacritics: RegExp;
}

declare var FB: any;
@Injectable({
    providedIn: 'root',
})
export class ToolsService {
  public availableServiceDurations = [
    { value: 5, string: '5m' },
    { value: 10, string: '10m' },
    { value: 15, string: '15m' },
    { value: 20, string: '20m' },
    { value: 25, string: '25m' },
    { value: 30, string: '30m' },
    { value: 35, string: '35m' },
    { value: 40, string: '40m' },
    { value: 45, string: '45m' },
    { value: 50, string: '50m' },
    { value: 55, string: '55m' },
    { value: 60, string: '1h' },
    { value: 70, string: '1h10' },
    { value: 75, string: '1h15' },
    { value: 80, string: '1h20' },
    { value: 90, string: '1h30' },
    { value: 100, string: '1h40' },
    { value: 105, string: '1h45' },
    { value: 110, string: '1h50' },
    { value: 120, string: '2h' },
    { value: 135, string: '2h15' },
    { value: 150, string: '2h30' },
    { value: 165, string: '2h45' },
    { value: 180, string: '3h' },
    { value: 195, string: '3h15' },
    { value: 210, string: '3h30' },
    { value: 225, string: '3h45' },
    { value: 240, string: '4h' },
    { value: 270, string: '4h30' },
    { value: 300, string: '5h' },
    { value: 330, string: '5h30' },
    { value: 360, string: '6h' },
    { value: 390, string: '6h30' },
    { value: 420, string: '7h' },
    { value: 450, string: '7h30' },
    { value: 480, string: '8h' },
    { value: 510, string: '8h30' },
    { value: 540, string: '9h' },
    { value: 570, string: '9h30' },
    { value: 600, string: '10h' },
  ];

  public workplanAvailableTimes = ['00:00', '00:15', '00:30', '00:45', '01:00', '01:15', '01:30', '01:45',
    '02:00', '02:15', '02:30', '02:45', '03:00', '03:15', '03:30', '03:45', '04:00', '04:15', '04:30',
    '04:45', '05:00', '05:15', '05:30', '05:45', '06:00', '06:15', '06:30', '06:45', '07:00', '07:15',
    '07:30', '07:45', '08:00', '08:15', '08:30', '08:45', '09:00', '09:15', '09:30', '09:45', '10:00',
    '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45',
    '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30',
    '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15',
    '18:30', '18:45', '19:00', '19:15', '19:30', '19:45', '20:00', '20:15', '20:30', '20:45', '21:00',
    '21:15', '21:30', '21:45', '22:00', '22:15', '22:30', '22:45', '23:00', '23:15', '23:30', '23:45'];

  public stripeErrorMessages = {
    incorrect_number: this.translate.instant('SHARED.paymentModal.stripeIncorrectNumber'),
    invalid_number: this.translate.instant('SHARED.paymentModal.stripeInvalidNumber'),
    invalid_expiry_month: this.translate.instant('SHARED.paymentModal.stripeinvalidExpiryNumber'),
    invalid_expiry_year: this.translate.instant('SHARED.paymentModal.stripeInvalidExpiryYear'),
    invalid_cvc: this.translate.instant('SHARED.paymentModal.stripeInvalidCVC'),
    expired_card: this.translate.instant('SHARED.paymentModal.stripeExpiredCard'),
    incorrect_cvc: this.translate.instant('SHARED.paymentModal.stripeIncorrectCVC'),
    incorrect_zip: this.translate.instant('SHARED.paymentModal.stripeIncorrectZip'),
    card_declined: this.translate.instant('SHARED.paymentModal.stripeCardDeclined'),
    missing: this.translate.instant('SHARED.paymentModal.stripeMissing'),
    processing_error: this.translate.instant('SHARED.paymentModal.stripeProcessingError'),
    rate_limit: this.translate.instant('GENERAL.generalErrorMsg'),
  };

  public arrayIannaTimeZones = ['Africa/Abidjan', 'Africa/Accra', 'Africa/Algiers', 'Africa/Bissau', 'Africa/Cairo', 'Africa/Casablanca', 'Africa/Ceuta', 'Africa/El_Aaiun', 'Africa/Johannesburg', 'Africa/Juba', 'Africa/Khartoum', 'Africa/Lagos', 'Africa/Maputo', 'Africa/Monrovia', 'Africa/Nairobi', 'Africa/Ndjamena', 'Africa/Sao_Tome', 'Africa/Tripoli', 'Africa/Tunis', 'Africa/Windhoek', 'America/Adak', 'America/Anchorage', 'America/Araguaina', 'America/Argentina/Buenos_Aires', 'America/Argentina/Catamarca', 'America/Argentina/Cordoba', 'America/Argentina/Jujuy', 'America/Argentina/La_Rioja', 'America/Argentina/Mendoza', 'America/Argentina/Rio_Gallegos', 'America/Argentina/Salta', 'America/Argentina/San_Juan', 'America/Argentina/San_Luis', 'America/Argentina/Tucuman', 'America/Argentina/Ushuaia', 'America/Asuncion', 'America/Atikokan', 'America/Bahia', 'America/Bahia_Banderas', 'America/Barbados', 'America/Belem', 'America/Belize', 'America/Blanc-Sablon', 'America/Boa_Vista', 'America/Bogota', 'America/Boise', 'America/Cambridge_Bay', 'America/Campo_Grande', 'America/Cancun', 'America/Caracas', 'America/Cayenne', 'America/Chicago', 'America/Chihuahua', 'America/Costa_Rica', 'America/Creston', 'America/Cuiaba', 'America/Curacao', 'America/Danmarkshavn', 'America/Dawson', 'America/Dawson_Creek', 'America/Denver', 'America/Detroit', 'America/Edmonton', 'America/Eirunepe', 'America/El_Salvador', 'America/Fort_Nelson', 'America/Fortaleza', 'America/Glace_Bay', 'America/Godthab', 'America/Goose_Bay', 'America/Grand_Turk', 'America/Guatemala', 'America/Guayaquil', 'America/Guyana', 'America/Halifax', 'America/Havana', 'America/Hermosillo', 'America/Indiana/Indianapolis', 'America/Indiana/Knox', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Tell_City', 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Inuvik', 'America/Iqaluit', 'America/Jamaica', 'America/Juneau', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/La_Paz', 'America/Lima', 'America/Los_Angeles', 'America/Maceio', 'America/Managua', 'America/Manaus', 'America/Martinique', 'America/Matamoros', 'America/Mazatlan', 'America/Menominee', 'America/Merida', 'America/Metlakatla', 'America/Mexico_City', 'America/Miquelon', 'America/Moncton', 'America/Monterrey', 'America/Montevideo', 'America/Nassau', 'America/New_York', 'America/Nipigon', 'America/Nome', 'America/Noronha', 'America/North_Dakota/Beulah', 'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/Ojinaga', 'America/Panama', 'America/Pangnirtung', 'America/Paramaribo', 'America/Phoenix', 'America/Port-au-Prince', 'America/Port_of_Spain', 'America/Porto_Velho', 'America/Puerto_Rico', 'America/Punta_Arenas', 'America/Rainy_River', 'America/Rankin_Inlet', 'America/Recife', 'America/Regina', 'America/Resolute', 'America/Rio_Branco', 'America/Santarem', 'America/Santiago', 'America/Santo_Domingo', 'America/Sao_Paulo', 'America/Scoresbysund', 'America/Sitka', 'America/St_Johns', 'America/Swift_Current', 'America/Tegucigalpa', 'America/Thule', 'America/Thunder_Bay', 'America/Tijuana', 'America/Toronto', 'America/Vancouver', 'America/Whitehorse', 'America/Winnipeg', 'America/Yakutat', 'America/Yellowknife', 'Antarctica/Casey', 'Antarctica/Davis', 'Antarctica/DumontDUrville', 'Antarctica/Macquarie', 'Antarctica/Mawson', 'Antarctica/Palmer', 'Antarctica/Rothera', 'Antarctica/Syowa', 'Antarctica/Troll', 'Antarctica/Vostok', 'Asia/Almaty', 'Asia/Amman', 'Asia/Anadyr', 'Asia/Aqtau', 'Asia/Aqtobe', 'Asia/Ashgabat', 'Asia/Atyrau', 'Asia/Baghdad', 'Asia/Baku', 'Asia/Bangkok', 'Asia/Barnaul', 'Asia/Beirut', 'Asia/Bishkek', 'Asia/Brunei', 'Asia/Chita', 'Asia/Choibalsan', 'Asia/Colombo', 'Asia/Damascus', 'Asia/Dhaka', 'Asia/Dili', 'Asia/Dubai', 'Asia/Dushanbe', 'Asia/Famagusta', 'Asia/Gaza', 'Asia/Hebron', 'Asia/Ho_Chi_Minh', 'Asia/Hong_Kong', 'Asia/Hovd', 'Asia/Irkutsk', 'Asia/Jakarta', 'Asia/Jayapura', 'Asia/Jerusalem', 'Asia/Kabul', 'Asia/Kamchatka', 'Asia/Karachi', 'Asia/Kathmandu', 'Asia/Khandyga', 'Asia/Kolkata', 'Asia/Krasnoyarsk', 'Asia/Kuala_Lumpur', 'Asia/Kuching', 'Asia/Macau', 'Asia/Magadan', 'Asia/Makassar', 'Asia/Manila', 'Asia/Nicosia', 'Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk', 'Asia/Oral', 'Asia/Pontianak', 'Asia/Pyongyang', 'Asia/Qatar', 'Asia/Qostanay', 'Asia/Qyzylorda', 'Asia/Riyadh', 'Asia/Sakhalin', 'Asia/Samarkand', 'Asia/Seoul', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Srednekolymsk', 'Asia/Taipei', 'Asia/Tashkent', 'Asia/Tbilisi', 'Asia/Tehran', 'Asia/Thimphu', 'Asia/Tokyo', 'Asia/Tomsk', 'Asia/Ulaanbaatar', 'Asia/Urumqi', 'Asia/Ust-Nera', 'Asia/Vladivostok', 'Asia/Yakutsk', 'Asia/Yangon', 'Asia/Yekaterinburg', 'Asia/Yerevan', 'Atlantic/Azores', 'Atlantic/Bermuda', 'Atlantic/Canary', 'Atlantic/Cape_Verde', 'Atlantic/Faroe', 'Atlantic/Madeira', 'Atlantic/Reykjavik', 'Atlantic/South_Georgia', 'Atlantic/Stanley', 'Australia/Adelaide', 'Australia/Brisbane', 'Australia/Broken_Hill', 'Australia/Currie', 'Australia/Darwin', 'Australia/Eucla', 'Australia/Hobart', 'Australia/Lindeman', 'Australia/Lord_Howe', 'Australia/Melbourne', 'Australia/Perth', 'Australia/Sydney', 'Europe/Amsterdam', 'Europe/Andorra', 'Europe/Astrakhan', 'Europe/Athens', 'Europe/Belgrade', 'Europe/Berlin', 'Europe/Brussels', 'Europe/Bucharest', 'Europe/Budapest', 'Europe/Chisinau', 'Europe/Copenhagen', 'Europe/Dublin', 'Europe/Gibraltar', 'Europe/Helsinki', 'Europe/Istanbul', 'Europe/Kaliningrad', 'Europe/Kiev', 'Europe/Kirov', 'Europe/Lisbon', 'Europe/London', 'Europe/Luxembourg', 'Europe/Madrid', 'Europe/Malta', 'Europe/Minsk', 'Europe/Monaco', 'Europe/Moscow', 'Europe/Oslo', 'Europe/Paris', 'Europe/Prague', 'Europe/Riga', 'Europe/Rome', 'Europe/Samara', 'Europe/Saratov', 'Europe/Simferopol', 'Europe/Sofia', 'Europe/Stockholm', 'Europe/Tallinn', 'Europe/Tirane', 'Europe/Ulyanovsk', 'Europe/Uzhgorod', 'Europe/Vienna', 'Europe/Vilnius', 'Europe/Volgograd', 'Europe/Warsaw', 'Europe/Zaporozhye', 'Europe/Zurich', 'Indian/Chagos', 'Indian/Christmas', 'Indian/Cocos', 'Indian/Kerguelen', 'Indian/Mahe', 'Indian/Maldives', 'Indian/Mauritius', 'Indian/Reunion', 'Pacific/Apia', 'Pacific/Auckland', 'Pacific/Bougainville', 'Pacific/Chatham', 'Pacific/Chuuk', 'Pacific/Easter', 'Pacific/Efate', 'Pacific/Enderbury', 'Pacific/Fakaofo', 'Pacific/Fiji', 'Pacific/Funafuti', 'Pacific/Galapagos', 'Pacific/Gambier', 'Pacific/Guadalcanal', 'Pacific/Guam', 'Pacific/Honolulu', 'Pacific/Kiritimati', 'Pacific/Kosrae', 'Pacific/Kwajalein', 'Pacific/Majuro', 'Pacific/Marquesas', 'Pacific/Nauru', 'Pacific/Niue', 'Pacific/Norfolk', 'Pacific/Noumea', 'Pacific/Pago_Pago', 'Pacific/Palau', 'Pacific/Pitcairn', 'Pacific/Pohnpei', 'Pacific/Port_Moresby', 'Pacific/Rarotonga', 'Pacific/Tahiti', 'Pacific/Tarawa', 'Pacific/Tongatapu', 'Pacific/Wake', 'Pacific/Wallis'];

  private diacritics: Diacritics[] = [
    { letter: ' ', diacritics: /\u00A0/g },
    { letter: '0', diacritics: /\u07C0/g },
    {
      letter: 'A',
      diacritics:
        /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g,
    },
    { letter: 'AA', diacritics: /\uA732/g },
    { letter: 'AE', diacritics: /[\u00C6\u01FC\u01E2]/g },
    { letter: 'AO', diacritics: /\uA734/g },
    { letter: 'AU', diacritics: /\uA736/g },
    { letter: 'AV', diacritics: /[\uA738\uA73A]/g },
    { letter: 'AY', diacritics: /\uA73C/g },
    { letter: 'B', diacritics: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g },
    { letter: 'C', diacritics: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g },
    { letter: 'D', diacritics: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g },
    { letter: 'Dh', diacritics: /\u00D0/g },
    { letter: 'DZ', diacritics: /[\u01F1\u01C4]/g },
    { letter: 'Dz', diacritics: /[\u01F2\u01C5]/g },
    {
      letter: 'E',
      diacritics:
        /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g,
    },
    { letter: 'F', diacritics: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g },
    { letter: 'G', diacritics: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g },
    { letter: 'H', diacritics: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g },
    {
      letter: 'I',
      diacritics:
        /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g,
    },
    { letter: 'J', diacritics: /[\u004A\u24BF\uFF2A\u0134\u0248]/g },
    { letter: 'K', diacritics: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g },
    {
      letter: 'L',
      diacritics: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g,
    },
    { letter: 'LJ', diacritics: /\u01C7/g },
    { letter: 'Lj', diacritics: /\u01C8/g },
    { letter: 'M', diacritics: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g },
    { letter: 'N', diacritics: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g },
    { letter: 'NJ', diacritics: /\u01CA/g },
    { letter: 'Nj', diacritics: /\u01CB/g },
    {
      letter: 'O',
      diacritics:
        /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g,
    },
    { letter: 'OE', diacritics: /\u0152/g },
    { letter: 'OI', diacritics: /\u01A2/g },
    { letter: 'OO', diacritics: /\uA74E/g },
    { letter: 'OU', diacritics: /\u0222/g },
    { letter: 'P', diacritics: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g },
    { letter: 'Q', diacritics: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g },
    {
      letter: 'R',
      diacritics: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g,
    },
    {
      letter: 'S',
      diacritics: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g,
    },
    { letter: 'T', diacritics: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g },
    { letter: 'Th', diacritics: /\u00DE/g },
    { letter: 'TZ', diacritics: /\uA728/g },
    {
      letter: 'U',
      diacritics:
        /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g,
    },
    { letter: 'V', diacritics: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g },
    { letter: 'VY', diacritics: /\uA760/g },
    { letter: 'W', diacritics: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g },
    { letter: 'X', diacritics: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g },
    { letter: 'Y', diacritics: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g },
    { letter: 'Z', diacritics: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g },
    {
      letter: 'a',
      diacritics:
        /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g,
    },
    { letter: 'aa', diacritics: /\uA733/g },
    { letter: 'ae', diacritics: /[\u00E6\u01FD\u01E3]/g },
    { letter: 'ao', diacritics: /\uA735/g },
    { letter: 'au', diacritics: /\uA737/g },
    { letter: 'av', diacritics: /[\uA739\uA73B]/g },
    { letter: 'ay', diacritics: /\uA73D/g },
    { letter: 'b', diacritics: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g },
    { letter: 'c', diacritics: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g },
    { letter: 'd', diacritics: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g },
    { letter: 'dh', diacritics: /\u00F0/g },
    { letter: 'dz', diacritics: /[\u01F3\u01C6]/g },
    {
      letter: 'e',
      diacritics:
        /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g,
    },
    { letter: 'f', diacritics: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g },
    { letter: 'ff', diacritics: /\uFB00/g },
    { letter: 'fi', diacritics: /\uFB01/g },
    { letter: 'fl', diacritics: /\uFB02/g },
    { letter: 'ffi', diacritics: /\uFB03/g },
    { letter: 'ffl', diacritics: /\uFB04/g },
    { letter: 'g', diacritics: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g },
    { letter: 'h', diacritics: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g },
    { letter: 'hv', diacritics: /\u0195/g },
    {
      letter: 'i',
      diacritics:
        /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g,
    },
    { letter: 'j', diacritics: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g },
    { letter: 'k', diacritics: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g },
    {
      letter: 'l',
      diacritics: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g,
    },
    { letter: 'lj', diacritics: /\u01C9/g },
    { letter: 'm', diacritics: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g },
    {
      letter: 'n',
      diacritics: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g,
    },
    { letter: 'nj', diacritics: /\u01CC/g },
    {
      letter: 'o',
      diacritics:
        /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g,
    },
    { letter: 'oe', diacritics: /\u0153/g },
    { letter: 'oi', diacritics: /\u01A3/g },
    { letter: 'ou', diacritics: /\u0223/g },
    { letter: 'oo', diacritics: /\uA74F/g },
    { letter: 'p', diacritics: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g },
    { letter: 'q', diacritics: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g },
    {
      letter: 'r',
      diacritics: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g,
    },
    {
      letter: 's',
      diacritics: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g,
    },
    { letter: 'ss', diacritics: /\xDF/g },
    { letter: 't', diacritics: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g },
    { letter: 'th', diacritics: /\u00FE/g },
    { letter: 'tz', diacritics: /\uA729/g },
    {
      letter: 'u',
      diacritics:
        /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g,
    },
    { letter: 'v', diacritics: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g },
    { letter: 'vy', diacritics: /\uA761/g },
    { letter: 'w', diacritics: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g },
    { letter: 'x', diacritics: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g },
    { letter: 'y', diacritics: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g },
    { letter: 'z', diacritics: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g },
  ];

  private routerHistory = [];

  constructor(
    private translate: TranslateService,
    @Inject(PLATFORM_ID) protected platformId,
    @Inject(DOCUMENT) private document: Document,
    private injector: Injector,
    private router: Router,
    @Optional() @Inject(REQUEST) private request: Request,
    private intlService: IntlService
  ) {}

  loadRouting(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(({ urlAfterRedirects }: NavigationEnd) => {
      this.routerHistory = [...this.routerHistory, urlAfterRedirects];
    });
  }

  getPreviousUrl(): string {
    return this.routerHistory[this.routerHistory.length - 2] || '/index';
  }

  parseServiceDurationToInt(string) {
    const toReturn = this.availableServiceDurations.find((v) => v.string === string);
    return toReturn && toReturn.value;
  }

  parseServiceDurationToString(int) {
    const toReturn = this.availableServiceDurations.find((v) => v.value === int);
    return toReturn && toReturn.string;
  }

  removeAccents(str) {
    const splited = str?.split('');
    const output = [];
    const accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž~"\'~^!?.:@#$%&*';
    const accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz-----';

    splited.forEach(function (value, index) {
      const hasAccent = accents.indexOf(value) !== -1;
      output[index] = hasAccent ? accentsOut.substr(accents.indexOf(value), 1) : value;
    });

    return output.join('');
  }

  slugify(text) {
    text = this.removeAccents(text.toString().toLowerCase());
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
  }

  getHeaderImg(merchant) {
    if (merchant) {
      const imgURL = {
        'background-image': merchant.headerImage
          ? 'url("' + merchant.headerImage + '?w=1600")'
          : 'url(' + this.getDefaultBgImage(merchant) + ')',
      };
      return imgURL;
    }
  }
  getHeaderImgUrl(merchant): string {
    if (merchant) {
      const imgURL = merchant.headerImage ? merchant.headerImage : this.getDefaultBgImage(merchant);
      return imgURL;
    }
    return '';
  }

  getDefaultBgImage(merchant) {
    let image = '';

    switch (merchant.type) {
      case 'hairsalon':
        // tslint:disable-next-line:max-line-length
        image =
          'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/store-bgimages%2Fcabeleireiro.jpg?alt=media&token=4b592ba5-8b94-4677-a1c0-d9575434bef2';
        break;
      case 'barber':
        // tslint:disable-next-line:max-line-length
        image =
          'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/store-bgimages%2Fbarber.jpg?alt=media&token=909b34ac-6c86-4e2e-8d0a-e710e0ddedf5';
        break;
      case 'realEstate':
      case 'consultancy':
        // tslint:disable-next-line:max-line-length
        image =
          'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/store-bgimages%2Fbusiness.jpg?alt=media&token=4b592ba5-8b94-4677-a1c0-d9575434bef2';
        break;

      case 'petService':
        // tslint:disable-next-line:max-line-length
        image =
          'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/store-bgimages%2Fpet.jpg?alt=media&token=56b86290-945a-47aa-a6d2-35e93086b34e';
        break;

      case 'dentist':
        // tslint:disable-next-line:max-line-length
        image =
          'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/store-bgimages%2Fdentist.jpg?alt=media&token=3c067303-5716-42fb-96c1-a14c1a841313';
        break;

      case 'veterinarian':
        // tslint:disable-next-line:max-line-length
        image =
          'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/store-bgimages%2Fpet.jpg?alt=media&token=56b86290-945a-47aa-a6d2-35e93086b34e';
        break;

      case 'photography':
        // tslint:disable-next-line:max-line-length
        image =
          'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/store-bgimages%2Fphoto.jpg?alt=media&token=5dee8462-0fbc-4927-8da9-94cf1d59aaca';
        break;

      case 'physiotherapy':
        // tslint:disable-next-line:max-line-length
        image =
          'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/store-bgimages%2Ffisioterapia.jpg?alt=media&token=4b592ba5-8b94-4677-a1c0-d9575434bef2';
        break;

      case 'sports':
        // tslint:disable-next-line:max-line-length
        image =
          'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/store-bgimages%2Fpt.jpg?alt=media&token=4b592ba5-8b94-4677-a1c0-d9575434bef2';
        break;

      case 'personalTrainer':
        // tslint:disable-next-line:max-line-length
        image =
          'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/store-bgimages%2Fpt.jpg?alt=media&token=4b592ba5-8b94-4677-a1c0-d9575434bef2';
        break;

      case 'spaMassages':
      case 'beautySalon':
        // tslint:disable-next-line:max-line-length
        image =
          'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/store-bgimages%2Fspa.jpg?alt=media&token=4b592ba5-8b94-4677-a1c0-d9575434bef2';
        break;

      default:
        // tslint:disable-next-line:max-line-length
        image =
          'https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/store-bgimages%2Fbusiness.jpg?alt=media&token=4b592ba5-8b94-4677-a1c0-d9575434bef2';
        break;
    }

    return image;
  }

  getDemoLink() {
    const hostConfig = environment.domains.find((v) => v.host === this.intlService.getHost());
    if (hostConfig) {
      return hostConfig.demoLink;
    }

    return 'https://calendly.com/bukdemo';
  }

  convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';

    for (var i = 0; i < array.length; i++) {
      var line = '';
      for (var index in array[i]) {
        if (line != '') line += ',';

        line += array[i][index];
      }

      str += line + '\r\n';
    }

    return str;
  }

  exportCSVFile(headers, items, fileTitle) {
    if (headers) {
      items.unshift(headers);
    }

    // Convert Object to JSON
    var jsonObject = JSON.stringify(items);

    var csv = this.convertToCSV(jsonObject);

    var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    if (navigator['msSaveBlob']) {
      // IE 10+
      navigator['msSaveBlob'](blob, exportedFilenmae);
    } else {
      var link = document.createElement('a');
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', exportedFilenmae);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  validateInvoiceNIF(nif: string) {
    if (!nif) {
      return true;
    }
    const validationSets = {
      one: ['1', '2', '3', '5', '6', '8'],
      two: ['45', '70', '71', '72', '74', '75', '77', '79', '90', '91', '98', '99'],
    };

    if (nif.length !== 9) {
      return false;
    }

    if (!validationSets.one.includes(nif.substr(0, 1)) && !validationSets.two.includes(nif.substr(0, 2))) {
      return false;
    }

    const nifNumbers = nif.split('').map((c) => Number.parseInt(c));
    const total =
      nifNumbers[0] * 9 +
      nifNumbers[1] * 8 +
      nifNumbers[2] * 7 +
      nifNumbers[3] * 6 +
      nifNumbers[4] * 5 +
      nifNumbers[5] * 4 +
      nifNumbers[6] * 3 +
      nifNumbers[7] * 2;

    const modulo11 = Number(total) % 11;

    const checkDigit = modulo11 < 2 ? 0 : 11 - modulo11;

    return checkDigit === Number(nif[8]);
  }

  localStorageSupport() {
    try {
      const key = '__localStorageSupport__';
      localStorage?.setItem(key, key);
      localStorage?.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  }

  adjustColor(color: string, amount: number) {
    return (
      '#' +
      color
        .replace(/^#/, '')
        .replace(/../g, (color) => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2))
    );
  }

  getDeviceType() {
    return 'ontouchstart' in document.documentElement ? 'mobile' : 'desktop';
  }

  getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'MS Edge';
      case agent.indexOf('edg/') > -1:
        return 'Edge ( chromium based)';
      case agent.indexOf('opr') > -1 && !!window['opr']:
        return 'Opera';
      case agent.indexOf('chrome') > -1 && !!window['chrome']:
        return 'Chrome';
      case agent.indexOf('trident') > -1:
        return 'MS IE';
      case agent.indexOf('firefox') > -1:
        return 'Mozilla Firefox';
      case agent.indexOf('safari') > -1:
        return 'Safari';
      default:
        return 'other';
    }
  }

  getMerchantOriginPayload() {
    if (isPlatformBrowser(this.platformId)) {
      let acquisitionDataRaw;
      let signupStepBeforeSignupUrl;
      try {
        acquisitionDataRaw = sessionStorage.getItem('acquisition:data');
      } catch (error) {

      }
      const acquisitionData = acquisitionDataRaw ? JSON.parse(acquisitionDataRaw) : {};

      try {
        signupStepBeforeSignupUrl = sessionStorage.getItem('signup:step:before:signup:url') ?? null;
      } catch (error) {

      }

      return {
        signupDevice: this.getDeviceType(),
        signupBrowser: this.getBrowserName(),
        ...acquisitionData,
        signupStepBeforeSignupUrl,
      };
    }

    return {};
  }

  getMerchantClientOriginPayload() {
    if (isPlatformBrowser(this.platformId)) {
      let acquisitionData;
      try {
        const acquisitionDataRaw = sessionStorage.getItem('acquisition:data');
        acquisitionData = acquisitionDataRaw ? JSON.parse(acquisitionDataRaw) : {};
      } catch (error) {

      }

      return {
        signupDevice: this.getDeviceType(),
        signupBrowser: this.getBrowserName(),
        ...acquisitionData,
      };
    }

    return {};
  }

  normalizeDiacritics(input?: string | null): string {
    if ('string' !== typeof input) {
      throw new TypeError(`Expected 'input' to be of type string, but received '${input}'`);
    }

    /**
     * NOTE(motss): Due to the fact that this module should do what we expect it to be - normalize
     * accents/ diacritics. However, some characters are not accented such as those from
     * [Latin-1 Supplement](https://bit.ly/2vz1l7m). Also see a relevant
     * [GH issue](https://bit.ly/2JbAmH0).
     *
     * Hence, to match the mental module of the users, `String.prototype.normalize` should not be used
     * as such.
     */
    return !input.length
      ? input
      : input.replace(/(\S)/g, (_, s: string) => {
          /**
           * `lastIndex` will not get reset for each comparison if we are reusing the same RegExp.
           * Here create a new copy of the RegExp instance before calling `.test()`.
           *
           * Issue: {@link https://github.com/motss/normalize-diacritics/issues/112|RegExp lastIndex}
           */
          const normalized = this.diacritics.find((n) => new RegExp(n.diacritics).test(s));
          return null == normalized ? s : normalized.letter;
        });
  }

  sha256Hash(message) {
    if (!message) {
      return;
    }
    try {
      return sha256(String(message));
    } catch (error) {
      console.error('Error converting message to string:', error);
      return;
    }
  }

  shareOnWhatsApp(text, url) {
    // Encode the text and URL for safe sending
    const encodedText = encodeURIComponent(text);
    const encodedURL = encodeURIComponent(url);

    // Create the WhatsApp URL
    const whatsappURL = `https://api.whatsapp.com/send?text=${encodedText}%20${encodedURL}`;

    // Open a new window/tab with the WhatsApp URL
    window.open(whatsappURL, '_blank');
  }

  shareOnFacebookSDK(text, url) {
    FB.ui({
      method: 'share',
      href: url,
      quote: text
    }, function(response){});
  }

  addressStringToAddressComponents(addressString: string) {
    const regex = /^(.*), (\d{4}-\d{3}) (.*)$/;
    const match = addressString?.match(regex);

    if (match) {
      const street = match[1].trim();
      const postalCode = match[2].trim();
      const cityCountry = match[3].trim();

      // Assuming the country is the last word
      const cityCountryParts = cityCountry.split(' ');
      const country = cityCountryParts.pop(); // Remove the last element, which should be the country
      const city = cityCountryParts.join(' ').replace(',', ''); // The rest is the city

      return {
        street,
        postalCode,
        city,
        country,
      };
    } else {
      return null;
    }
  }

  convertBase64ToBlob(Base64Image: string) {
    // split into two parts
    const parts = Base64Image.split(";base64,")
    // hold the content type
    const imageType = parts[0].split(":")[1]
    // decode base64 string
    const decodedData = window.atob(parts[1])
    // create unit8array of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length)
    // insert all character code into uint8array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i)
    }
    // return blob image after conversion
    return new Blob([uInt8Array], { type: imageType })
  }

  isSafariBefore17() {
      let ua = navigator.userAgent;

      // Check if it's Safari (excluding Chrome, Edge, etc.)
      let isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);

      if (!isSafari) return false; // Not Safari

      // Extract Safari version
      let match = ua.match(/Version\/(\d+)\./); // Gets the major version number
      if (match && match[1]) {
          let safariVersion = parseInt(match[1], 10);
          return safariVersion < 17;
      }

      return false; // Couldn't determine version
  }

  getCookie(name: string): string | null {
    const cookies = this.document.cookie.split('; ');
    const cookie = cookies.find(row => row.startsWith(`${name}=`));
    return cookie ? cookie.split('=')[1] : null;
  }



}
